<template>
  <div class="link-com">
    <tx-btn src="logo" class="logo" name="主页"/>

    <!-- 网页疑问 -->
    <rule-btn />

    <div class="header">
      <TxBtn
        src="xiazaiyouxi"
        name="下载游戏"
        @click="openExternal(urls.download)"
      />
      <TxBtn
        src="qianwangguanwang"
        name="前往官网"
        @click="openExternal(urls.website)"
      />
    </div>

    <TxBtn
      src="bangdan-shouqi"
      class="shouqi"
      name="更多榜单"
      @click="is_shouqi = !is_shouqi"
    />
    <TxBg src="bangdan-zhankaidiban" class="zhankaidiban" v-if="!is_shouqi">
      <div class="tx3bangdan-wrapper">
        <div>
          <TxBtn
            src="tx3bangdan"
            name="天下3英雄榜"
            @click="openExternal(urls.tx3_rank)"
          />
          <TxBtn
            src="tx2bangdan"
            name="天下贰英雄榜"
            @click="openExternal(urls.tx2_rank)"
          />
        </div>

        <div class="tx3bangdan-tools">
          <TxBtn
            src="xiazai"
            name="下载游戏"
            @click="openExternal(urls.download)"
          />
          <div class="tx3bangdan-tools2">
            <!-- <TxBtn
              src="yancheng"
              name="远程工具"
              @click="openExternal(urls.remote_tool)"
            /> -->
            <TxBtn
              src="yunyouxi"
              name="云游戏"
              @click="openExternal(urls.yun_game)"
            />
          </div>
        </div>
      </div>
    </TxBg>

    <!-- <TxFooter /> -->

    <div class="tx-footer wrap_bg">
      <div id="NIE-copyRight"></div>
    </div>
  </div>
</template>

<script setup>
const { is_mobile, urls } = inject('GlobalStore');
let is_shouqi = ref(true);

// 基础跳转方法
const openExternal = (url, newWindow = true) => {
  if (!url) return;
  if (newWindow) {
    window.open(url, '_blank', 'noopener,noreferrer');
  } else {
    window.location.href = url;
  }
};

onMounted(() => {
  nie.util.copyRight();
});
</script>

<style scoped lang="scss" postcss="false">
.wrap_bg {
  width: 100vw;
  height: 250px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.tx3bangdan-tools2 {
  justify-content: center;
}
</style>